import { call, put } from 'redux-saga/effects';
import { photoCaptureDataFailureAction, photoCaptureGetContextDataAction, photoCaptureIntelligentGetDownloadAuthDetailsDataSuccessAction } from '../actions';
import { DOWNLOAD_ARTIFACT_MESSAGES, GPCLoaderConstants } from '../constants';
import { PhotoCaptureIntelligentDownloadAuthDetailsService } from '../services';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
import { GuidedPhotoCapture } from '../enums';
export function* photoCaptureIntelligentGetDownloadAuthDetailsSaga(action, photoCaptureIntelligentDownloadAuthDetailsService = new PhotoCaptureIntelligentDownloadAuthDetailsService()) {
    const { coCode, contextId } = action.payload;
    try {
        const response = yield call({
            context: photoCaptureIntelligentDownloadAuthDetailsService,
            fn: photoCaptureIntelligentDownloadAuthDetailsService.photoCaptureIntelligentGetDownloadAuthDetailsData
        }, coCode, contextId);
        if (response && response.authToken) {
            yield put(photoCaptureIntelligentGetDownloadAuthDetailsDataSuccessAction(response));
            localStorage.setItem(GPCLoaderConstants.ACCESS_TOKEN, response.authToken);
            if (response.taskStatus &&
                response.taskStatus.toUpperCase() === GuidedPhotoCapture.TASK_STATUS_CLOSED &&
                response.downloadAllowed) {
                if (!response.downloadLinkExpired) {
                    yield put(photoCaptureGetContextDataAction(coCode, contextId));
                }
            }
            else {
                // Case 1: Download not allowed or task not closed
                yield put(photoCaptureDataFailureAction(DOWNLOAD_ARTIFACT_MESSAGES.NOT_PERMITTED));
            }
        }
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureDataFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureDownloadAuthDetailsSaga.js.map